'use client';

import { usePathname } from 'next/navigation';
import { useEffect } from 'react';

const DIGIOH_SCRIPT_ID = 'digioh';

const DIGIOH_SCRIPT_SRC =
  'https://www.lightboxcdn.com/vendor/07b078a4-9b29-43f4-8a64-625162ac0d22/lightbox_speed.js';

const SEEN_SESSION_STORAGE_KEY = 'digioh-popup-seen-this-session';

function isPaidLandingPage(pathname: string | null): boolean {
  return pathname === '/ready' || Boolean(pathname?.startsWith('/ready/'));
}

function isVIPPage(pathname: string | null): boolean {
  return pathname === '/vip';
}

function hasSeenPopupThisSession(): boolean {
  try {
    return window.sessionStorage.getItem(SEEN_SESSION_STORAGE_KEY) === 'true';
  } catch {
    return false;
  }
}

function rememberPopupSeenThisSession(): void {
  try {
    window.sessionStorage.setItem(SEEN_SESSION_STORAGE_KEY, 'true');
  } catch {
    // Ignore storage access errors.
  }
}

function loadDigiohScript(): void {
  if (document.getElementById(DIGIOH_SCRIPT_ID)) {
    return;
  }

  const script = document.createElement('script');

  script.id = DIGIOH_SCRIPT_ID;
  script.src = DIGIOH_SCRIPT_SRC;
  script.async = true;
  script.onload = rememberPopupSeenThisSession;

  document.body.appendChild(script);
}

export default function DigiohScript() {
  const pathname = usePathname();

  useEffect(() => {
    if (isPaidLandingPage(pathname)) {
      return;
    }

    if (hasSeenPopupThisSession() && !isVIPPage(pathname)) {
      return;
    }

    loadDigiohScript();
  }, [pathname]);

  return null;
}
